import { useEffect, useState } from 'react';
import { supabase } from '../lib/supabase';

type AppType = 'worker' | 'recruiter';

export function useAppDownload(appType: AppType) {
  const [downloadUrl, setDownloadUrl] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let isMounted = true;

    const load = async () => {
      setLoading(true);

      try {
        const { data, error } = await supabase.rpc('get_app_version_status', {
          p_app_type: appType,
          p_platform: 'android',
          p_version: '0.0.0',
          p_build_number: 0,
        });

        const rpcRow = Array.isArray(data) ? data[0] : data;
        if (!error && rpcRow?.download_url) {
          if (isMounted) {
            setDownloadUrl(rpcRow.download_url);
            setLoading(false);
          }
          return;
        }

        const { data: releases } = await supabase
          .from('app_versions')
          .select('download_url')
          .eq('app_type', appType)
          .eq('platform', 'android')
          .eq('is_active', true)
          .eq('is_enabled', true)
          .not('download_url', 'is', null)
          .order('build_number', { ascending: false })
          .order('created_at', { ascending: false })
          .limit(1);

        if (isMounted) {
          setDownloadUrl(releases?.[0]?.download_url || null);
          setLoading(false);
        }
      } catch (error) {
        console.warn(`Failed to load ${appType} download URL from database.`, error);
        if (isMounted) {
          setDownloadUrl(null);
          setLoading(false);
        }
      }
    };

    void load();

    return () => {
      isMounted = false;
    };
  }, [appType]);

  return { downloadUrl, loading };
}
